import Joi from 'joi-full';
import { reduxForm } from 'redux-form';

import { syncValidateData } from '../../../../../common/validator';
import { REPORT_TYPES } from '../../constants';
import { getCustomReportLink } from '../../utils';

const CUSTOM_REPORT_FORM = 'custom-report';

const schema = Joi.object().keys({
  name: Joi.string().min(2).max(200).required(),
  type: Joi.string().valid(REPORT_TYPES.BARBER, REPORT_TYPES.LOCATION).required(),
  reportMetrics: Joi.array().items(
    Joi.object().keys({
      breakdownSelected: Joi.boolean(),
      name: Joi.string().required(),
      id: Joi.string().required(),
    })
  ),
});

const asyncValidate = async (values) => {
  if (!values.reportMetrics.length) {
    throw { // eslint-disable-line no-throw-literal
      code: 'No report fields selected.',
      isValidationError: true,
    };
  }
};

export default reduxForm({
  form: CUSTOM_REPORT_FORM,
  enableReinitialize: true,
  validate: values => syncValidateData(values, schema),
  asyncValidate,
  onSubmitSuccess: (_values, _dispatch, props) => {
    if (!_values) {
      return;
    }

    props.router.push(`${props.urlPrefix}${getCustomReportLink(_values)}`);
    props.addNotification({
      level: 'success',
      message: 'Report template is saved.',
      title: 'Success',
    });
  },
  onSubmitFail: (error, _dispatch, _, props) => {
    if (error && error.isValidationError) {
      props.addNotification({
        level: 'error',
        message: error.code,
        title: 'Error',
        autoDismiss: 5,
      });
    }
  },
});
